import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { COLORS, SIZE } from "constants/variables";

export const ProjectsCarouselContainer = styled.div``;

export const ProjectsSlider = styled(Slider)`
  margin-left: ${SIZE.max12};
  .slick-slide {
    transition: transform 0.3s ease, opacity 0.3s ease;
    padding-inline: ${SIZE.max12};
  }

  @media (width <= 768px) {
    margin-left: 0;
    .slick-slide {
      padding-top: ${SIZE.max180};
      padding-inline: ${SIZE.max24};
    }
    .slick-center {
      transform: scale(1.1, 1.2) translate(0, -8%);
    }
  }
`;

export const ProjectsSliderItem = styled.div`
  aspect-ratio: 1/1.4;
  @media (width <= 768px) {
    aspect-ratio: 1/1.2;
  }
`;

export const CarouselScrollbar = styled.div`
  display: flex;
  justify-content: center;
  height: ${SIZE.max12};
  padding-top: ${SIZE.max24};
`;

export const CarouselDot = styled.div`
  border-radius: 50%;
  height: ${SIZE.max12};
  width: 50%;
  display: flex;
  justify-content: space-between;

  & > li {
    background-color: ${COLORS.Background};
    transition: background-color 0.3s ease-out, border-radius 0.3s ease-out;
    border-radius: 50%;
    width: 12px;
    height: 12px;
  }
  & > li.slick-active {
    border-radius: 50%;
    background-color: ${COLORS.Yellow};
    transition: background-color 0.3s ease-out, border-radius 0.3s ease-out;
  }
`;

export const CarouselDotButton = styled.div`
  background-color: inherit;
`;
